// Login page - first page users see
// Enter email and password to access dashboard


/**
 * NOTES-SUMMARY-LOGIN PAGE
 * 
 * What this page does:
 *  - Shows login form with email and password fields
 *  - When submitted, calls login API
 *  - If successful, saves token and redirects to dashboard
 *  - If failed, shows error message
 */



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as apiLogin } from '../utils/api';
import { setToken, setUser } from '../utils/auth';
import '../styles/App.css';

function Login() {
  const navigate = useNavigate();
  
  // Form state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    
    setError('');
    setLoading(true);
    
    try {
      // Call login API
      const response = await apiLogin(email, password);
      
      // Save token and user info
      setToken(response.token);
      setUser(response.user);
      
      // Redirect to dashboard
      navigate('/dashboard');
      
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-container">
      <div className="login-box">
        <img 
          src="/logo.png" 
          alt="Plan Participant Logo" 
          className="login-logo"
        />
        <h1 className="login-title">Welcome Back</h1>
        <p className="login-subtitle">Sign in to access your dashboard</p>
        
        <form onSubmit={handleSubmit} className="login-form" noValidate>
          {error && (
            <div className="alert alert-error">{error}</div>
          )}
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
              placeholder="user@planparticipant.com"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
              placeholder="Enter your password"
            />
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;